module.exports = __webpack_public_path__ + "img/fa0efc05-2970-4a0f-82be-bf627ed13afc.d8b6c4bd.png";